import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconBrandingDsgMono,
	homefieldIconChainLink,
	homefieldIconNikeLogo,
	homefieldIconNikeMember,
	homefieldIconNikeShoe,
	homefieldIconRewards
} from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { ExclusiveProductOverlayComponent } from './exclusive-product-overlay.component';
import { NgModule } from '@angular/core';

@NgModule({
	declarations: [
		ExclusiveProductOverlayComponent
	],
	imports: [
		CommonModule,
		HomefieldIconLibraryModule
	],
	exports: [
		ExclusiveProductOverlayComponent
	]
})
export class ExclusiveProductOverlayModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons(
			[
				homefieldIconNikeLogo,
				homefieldIconBrandingDsgMono,
				homefieldIconChainLink,
				homefieldIconNikeShoe,
				homefieldIconNikeMember,
				homefieldIconRewards
			]);
	}
}
